import axios from "axios";
import firebase from "firebase";
import flash from "../../../functions/flash";
import { searchResults } from "../../endpoints";

const getApprovedApplications = (uid, setNotarizeData, setLoading, accessToken) => {
  try {
    setLoading(true);
    let ref = firebase.database().ref("notarize").orderByChild("status").equalTo("COMPLETE");

    ref.on(
      "value",
      async (o) => {
        let arr = [];
        if (o.exists()) {
          let keys = Object.keys(o.val());
          let getEmails = await axios.post(searchResults, { accessToken, uids: keys });
          let values = Object.values(o.val());
          keys = keys.map((o, i) => ({ key: o, ...values[i] }));

          for (const i of keys) {
            let profile = await firebase.database().ref("users").child(i.key).once("value");
            if (profile.exists()) {
              let find = getEmails.data.data.find((r) => r.uid === i.key);
              const { email } = find || {};
              arr.push({ ...profile.val(), ...i, email: email ? email : "Not Found / User Deleted" });
            }
          }
          setNotarizeData(arr);
        } else setTimeout(() => setNotarizeData([]), 500);
        setLoading(false);
      },
      (e) => {
        if (!uid) ref.off();
      }
    );
  } catch (e) {
    console.log(e);
    setNotarizeData([]);
    setLoading(false);
    flash(e.message, "danger");
  }
};

export default getApprovedApplications;
